<template>
    <div style="width:100%">
        <div id="Dashboard-left"></div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            EchartMiddleOption:{},
            demoDataObj:{
            name: '',
            unit: '亿元',
            value: 139.0277,
            },
            max:200,
        timer:null,
           middleValue:1390277

        }
    },
    mounted(){
        this.getEchartMiddle()
        this.timer = setInterval(this.echartMove, 3500);

    },
    methods:{
        echartMove(){
      setTimeout(() => {
          console.log("多久",this.demoDataObj.value)
          if(this.demoDataObj.value==0){
              this.demoDataObj.value=139.0277
              this.middleValue=1390277
          }else{
               this.demoDataObj.value=0
               this.middleValue=0
          }

          this.getEchartMiddle()
      }, 10000);
        },
        getEchartMiddle(){
        let that = this;
        var myChart = that.$echarts.init(document.getElementById('Dashboard-left'));
        var demoData = this.demoData
        let option = {
                            animation: true,
animationDuration: 3000,
            // backgroundColor: '#010101',
                title: {
                    text: `概算金额`,//  \n换行
                    subtext: ['预算金额', '1265100万元'].join(' '), // 主副标题
                    // subtext: '综合健康评分',
                    left: 'center',
                    // top: 'center', //top待调整
                    bottom:'2%',
                    textStyle: {
                        color: '#fff',
                        fontSize: 16,
                        fontFamily: 'DINAlternate-Bold',
                    },
                    subtextStyle: {
                        color: '#ff',
                        fontSize: 14,
                        fontFamily: 'PingFangSC-Regular',
                        top: 'center'
                    },
                    itemGap: 10 //主副标题间距
                },
            series:[
                    {
                        // 绿色半圆第一环
                        name: this.demoDataObj.name,
                        type: 'gauge',
                        radius: '84.10%',
                        startAngle: 225,
                        endAngle: -45,
                        min: 0,
                        max: this.max,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 6,
                                shadowBlur: 10,
                                color: [
                                    // 最外圈颜色
                                    [1, 'rgb(29,154,255)']
                            // [0, 'transparent'],
                            // [0.1, 'rgb(29,154,255)'],
                            // [0.101, 'transparent'],
                            // [0.2, 'rgb(29,154,255)'],
                            // [0.201, 'transparent'],
                            // [0.3, 'rgb(29,154,255)'],
                            // [0.301, 'transparent'],
                            // [0.4, 'rgb(29,154,255)'],
                            // [0.401, 'transparent'],
                            // [0.5, 'rgb(29,154,255)'],
                            // [0.501, 'transparent'],
                            // [0.6, 'rgb(29,154,255)'],
                            // [0.601, 'transparent'],
                            // [0.7, 'rgb(29,154,255)'],
                            // [0.701, 'transparent'],
                            // [0.8, 'rgb(29,154,255)'],
                            // [0.801, 'transparent'],
                            // [0.9, 'rgb(29,154,255)'],
                            // [0.901, 'transparent'],
                            // [1, 'rgb(29,154,255)']
                        ],
                            }
                        },
                        axisTick: {
                            show: 0,
                        },
                        splitLine: {
                            show: 0,
                        },
                        axisLabel: {
                            show: 0
                        },
                        pointer: {
                            show: false,
                        },
                        detail: {
                            show: false,
                        },
                        data: [{
                            show: false,
                        }]},
                    {//中心圆圈数字内环
                        "type": 'pie',
                        "hoverAnimation": false,
                        "legendHoverLink": false,
                        "radius": ['39%', '43%'],
                        // "z": 10,
                        "label": {
                            "normal": {
                                "show": false
                            }
                        },
                        "labelLine": {
                            "normal": {
                                "show": false
                            }
                        },
                        "data": [{
                            "value": this.max,
                            itemStyle: {
                                normal: {
                                    color: "rgb(0,94,255)"
                                }
                            }
                        }]
                    },
                {
                    name: "最外部左右半圆宽线条",
                    type: "gauge",
                    radius: '98%',
                    startAngle: 225,
                    endAngle: -45,
            //                    animationEasing: "linear",
            //   animationEasingUpdate: "quadraticIn",  //数据更新时的缓动效果
            //   animationDurationUpdate: 1000,  //数据更新动画的时长
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 5,
                                color: [
                                    [
                                        // 指针光带渐变rgba(0,85,255,0)
                                        1, new that.$echarts.graphic.LinearGradient(
                                            0, 1, 1, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(0,85,255,1)',
                                                }, {
                                                    offset: 0.3,
                                                    color: 'rgba(0,85,255,0)',
                                                },
                                                {
                                                    offset: 0.7,
                                                    color: 'rgba(0,85,255,0)',
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(0,85,255,1)',
                                                }
                                            ]
                                        )
                                    ],
                                    [
                                        1, 'rgba(255,255,255,.0)'
                                    ]
                                ],
                            }
                        },
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    detail: {
                        show: false
                    },
                    title: {
                        show: false,
                    }
                },
                {
                    name: "指针尖尖上宽线条",
                    type: "gauge",
                    radius: '74%',
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                        lineStyle: {
                            color: [
                                [1, 'rgb(0,85,255)']
                            ],
                            width: 7
                        }
                    },
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    detail: {
                        show: false
                    },
                    title: {
                        show: false,
                    }
                },
                        {
                        name: this.demoDataObj.name,
                        type: 'gauge',
                        radius: '81%',
                        startAngle: 225,
                        endAngle: -45,
                        min: 0,
                        max: this.max,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 56,
                                color: [
                                    [
                                        // 指针光带渐变rgba(0,85,255,0)
                                        this.demoDataObj.value / this.max, new that.$echarts.graphic.LinearGradient(
                                            0, 1, 1, 0, [{
                                                    offset: 0,
                                                    color: 'rgba(0,85,255,0)',
                                                }, {
                                                    offset: 0.3,
                                                    color: 'rgba(0,85,255,0.3)',
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(0,85,255,1)',
                                                }
                                            ]
                                        )
                                    ],
                                    [
                                        1, 'rgba(255,255,255,.0)'
                                    ]
                                ],
                            }
                        },
                        axisTick: {
                            show: 0,
                        },
                        splitLine: {
                            show: 0,
                        },
                        axisLabel: {
                            show: 0
                        },
                        // pointer: {
                        //     show: true,
                        //     length: '100%'
                        // },
                        title:{
                            show:false,
                        },
                        detail: {
                            show: true,
                            valueAnimation: true,
                            offsetCenter: [0, '55%'],
                            textStyle: {
                                // 最终数值样式
                                fontSize: 20,
                                color: '#fff',
                                // offsetCenter: [0,'80%']
                            },
                            formatter: [
                                '{value}\n' + (this.demoDataObj.unit || ''),
                                // this.middleValue+'\n' + (this.demoDataObj.unit || ''),
                                '{name|' + this.demoDataObj.name + '}'
                            ].join('\n'),
                            rich: {
                                name: {
                                    show:false,
                                    // 标题样式
                                    fontSize: 20,
                                    lineHeight: 120,
                                    color: '#fff',
                                    fontWeight: '600',
                                    // offsetCenter: ["0", "53%"]
                                
                                },
                                
                            }
                        },
                        itemStyle: {
                            color: 'rgb(0,230,253)',//指针边框颜色
                            borderColor: 'rgb(0,230,253)',//指针填充背景颜色
                        },
                    pointer: {
                        show: true,
                        length: '35%',
                        // radius: '20%',
                        width: 5, //指针粗细
                        // offsetCenter:[-50,373],
                        offsetCenter: [0, -70]
                    },
                        data: [{
                            value: this.demoDataObj.value,
                            title:{
                                show:true,
                            },
                        }]
                        }, 
                        {
                            // 紧贴绿色第一圈的第二圈
                        type: 'gauge',
                        radius: '81%',
                        splitNumber: 10,
                        min: 0,
                        max: this.max,
                        startAngle: 225,
                        endAngle: -45,
                        z:9,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 5,
                                color: [
                                    [1,
                                        new that.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                            // 刻度边颜色yellow
                                            {
                                                offset: 0,
                                                color: 'rgb(0,85,255)'
                                            },
                                            {
                                                offset: 1,
                                                color: 'rgb(0,85,255)'
                                            }
                                        ])
                                    ]
                                ],
                            }
                        },
                        axisLabel: {
                            distance: 6,
                            textStyle: {
                                // 整数刻度线颜色 0 10 20....
                                color: '#fff',
                                fontSize: '14'
                            }
                        },
                        splitLine: {
                            show: true,
                            length: 16,
                            lineStyle: {
                                // 整数刻度数字颜色 0 10 20....
                                color: "#fff",
                            }
                        },
                        // detail: {
                        //     show: 0
                        // }
                    }
            ]
            // series: (function() {
            //     var result = [];
            //     demoData.forEach(function(item) {
            //         result.push(
            //             , );
            //     });

            //     return result;
            // })()
        };
        option && myChart.setOption(option);
        window.onresize = function(){
            myChart.resize();
        }
        }

    },
    
}
</script>
<style lang="less" scoped>
#Dashboard-left{
    width: 100%;
    height: 260px;

}

</style>


// WEBPACK FOOTER //
// src/components/cockpitCh/echarts/DashboardLeft.vue